export default __webpack_public_path__ + "static/media/logo.e98b599a.svg";